import { render, staticRenderFns } from "./TrendTabbar.vue?vue&type=template&id=4c74cca0&scoped=true&"
import script from "./TrendTabbar.vue?vue&type=script&lang=js&"
export * from "./TrendTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c74cca0",
  null
  
)

export default component.exports